import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ThemePalette } from '@angular/material/core'

@Component({
  selector: 'bdg-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  @Input()
  type: LabelType = 'body-1'

  @Input()
  color: ThemePalette | string = ''

  @Input()
  toolTip = ''

  @Input()
  required = false

  get style() {
    return !this.isThemeColor() ? `--color: ${this.color}` : ''
  }

  get class() {
    const colorClass = this.isThemeColor() ? `color-${this.color}` : 'custom-color'
    return `mat-${this.type} ${colorClass}`
  }

  private isThemeColor() {
    return ['accent', 'primary', 'warn'].indexOf(this.color) > -1
  }
}

export type LabelType =
  | 'display-4'
  | 'display-3'
  | 'display-2'
  | 'display-1'
  | 'headline'
  | 'title'
  | 'subheading-2'
  | 'subheading-1'
  | 'body-2'
  | 'body-1'
  | 'button'
  | 'caption'
  | 'input'
